/* eslint-disable require-unicode-regexp */
import angular from 'angular';
const dependencies = window.importAngularDependencies(require.context('./', true, /^(?!.*\.(spec|test)\.(angular)\.(tsx|ts)$).*\.(angular)\.(tsx|ts)$/), './sso.ts');
export default angular.module('doxy.sso', dependencies).name;
